import React from 'react'
import Main from './components/game/Main'
import store from './store/store'
import { Provider } from 'react-redux'
import ReactGA from 'react-ga4'
import NavBar from './components/NavBar/NavBar'

function App() {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID as string, {
      gaOptions: { debug: true },
    })
  }

  window.location.replace('https://languageguessr.io')

  return (
    <Provider store={store}>
      <div className="App">
        <NavBar />
        <Main />
      </div>
    </Provider>
  )
}

export default App
